import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import SectionHeading from "@/components/base/SectionHeading";
import { works } from "@/mocks/works";
import { newsList } from "@/mocks/news";
import { collections } from "@/mocks/collections";
import { relativeTime, truncate } from "@/utils/format";
import HeroCarousel from "./components/HeroCarousel";
import CategoryQuickLinks from "./components/CategoryQuickLinks";
import FeaturedCollections from "./components/FeaturedCollections";
import BrandIntro from "./components/BrandIntro";
import LatestNews from "./components/LatestNews";

export default function Home() {
  const featured = works.filter((w) => w.featured);
  const latestWorks = [...works]
    .sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime())
    .slice(0, 11);
  const latestNews = [...newsList]
    .sort((a, b) => new Date(b.publishTime).getTime() - new Date(a.publishTime).getTime())
    .slice(0, 6);

  return (
    <SiteLayout>
      <HeroCarousel items={featured.length >= 3 ? featured : works.slice(0, 4)} />

      <CategoryQuickLinks />

      {/* 最新影视作品 */}
      <section className="mx-auto w-full px-4 pt-14 md:px-6">
        <SectionHeading
          title="最新影视作品"
          subtitle="按更新时间为你精选 · 电影 / 电视剧 / 综艺"
          moreTo="/category"
        />
        <div className="columns-2 gap-4 md:columns-3 lg:columns-4 [&>*]:mb-4">
          {latestWorks.map((work) => (
            <Link
              key={work.id}
              to={`/detail/${work.id}`}
              className="group block break-inside-avoid overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative w-full overflow-hidden bg-background-200" style={{ aspectRatio: "2 / 3" }}>
                <img
                  src={work.cover}
                  alt={`${work.title}封面图`}
                  title={`${work.title} - 糖心传媒`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-semibold text-background-50">
                  <i className="ri-star-fill text-accent-400" />
                  {work.rating.toFixed(1)}
                </span>
              </div>
              <div className="p-3">
                <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-600">
                  {work.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">
                  {work.year} · {work.genre.join(" / ")}
                </p>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                  {truncate(work.summary, 40)}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* 最新资讯 + 热门专题横向入口 */}
      <section className="mx-auto mt-14 w-full px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <SectionHeading title="最新影视资讯" subtitle="掌握影视圈每一天的新鲜事" moreTo="/news" />
            <LatestNews items={latestNews} />
          </div>
          <div>
            <SectionHeading title="热门专题" subtitle="编辑精选合集" />
            <div className="flex flex-col gap-4">
              {collections.slice(0, 3).map((c) => (
                <Link
                  key={c.id}
                  to={`/category?collection=${c.id}`}
                  className="group flex gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-accent-300"
                >
                  <div className="h-20 w-28 shrink-0 overflow-hidden rounded-md bg-background-200">
                    <img
                      src={c.cover}
                      alt={`${c.title}专题图`}
                      title={`${c.title} - 糖心传媒专题`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex min-w-0 flex-col justify-center">
                    <h3 className="truncate text-sm font-bold text-foreground-950 group-hover:text-primary-600">
                      {c.title}
                    </h3>
                    <p className="mt-1 text-xs font-medium text-accent-600">{c.subtitle}</p>
                    <p className="mt-1 text-xs text-foreground-500">{c.workIds.length} 部作品</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      <div className="mt-14">
        <FeaturedCollections items={collections} />
      </div>

      <BrandIntro />
    </SiteLayout>
  );
}